<template>
  <div class="score">{{score}}</div>
</template>

<script>
  export default {
    name: 'Score',
    props: ['score']
  }
</script>



// WEBPACK FOOTER //
// src/components/Score.vue